import { defineMessages } from "react-intl";

export const messages = defineMessages({
    poweredByText: {
        id: "TransparentTemplateV2.itSupport.serviceManagement.poweredByText",
        defaultMessage: "Powered by",
        description:
            "Text indicating that the template is powered by a third party service"
    },
    legalNotice: {
        id: "TransparentTemplateV2.itSupport.serviceManagement.legalNotice",
        defaultMessage:
            "By selecting this template, you agree to the {customerAgreementLink} and {privacyPolicyLink}.",
        description:
            "Informs user that by selecting the template they agree with the customer agreement and privacy policy."
    },
    customerAgreementLinkText: {
        id: "oTransparentTemplateV2.itSupport.serviceManagement.customerAgreementLink",
        defaultMessage: "Atlassian Customer Agreement",
        description:
            "Link text for the Atlassian Customer Agreement legal document"
    },
    privacyPolicyLinkText: {
        id: "TransparentTemplateV2.itSupport.serviceManagement.privacyPolicyLink",
        defaultMessage: "Privacy Policy",
        description: "Link text for the Privacy Policy legal document"
    },
    additionalInfo: {
        id: "TransparentTemplateV2.itSupport.serviceManagement.additionalInfo",
        defaultMessage:
            "You will be redirected to {productName} and provisioned to Service Collection. You will still have access to Jira on your site.",
        description:
            "Additional information shown for product templates explaining the redirect and access"
    }
});
